import React from "react";
import VideoInicio from "./VideoInicio";
import TiempoLimitado1 from "./TiempoLimitado1";
import Gestion from "./Gestion";
import Laptop from "./Laptop";
import Herramientas from "./Herramientas";
import TiempoLimitado2 from "./TiempoLimitado2";

const PromocionBlustay = () => {
    return (
        <div>
            <VideoInicio />
            <TiempoLimitado1 />
            <Gestion />
            <Laptop />
            <Herramientas />
            <TiempoLimitado2 />
        </div>
    );
};

export default PromocionBlustay;
